/* Copyright (c) 2024, 2025 - Liam M. Murphy */

import React from "react";

class CustomFooter extends React.Component {
    render() {
        return (
            <div className="custom-footer">
                <p>Copyright &copy; 2019-2025 &sdot; Liam M. Murphy</p>
            </div>
        );
    }
}

export default CustomFooter;
